import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  p {
    margin: 0 auto;
    text-align: center;
  }

  span {
    margin: 2vh auto;
  }
`;
